// import './instrument';
// import 'bootstrap/dist/css/bootstrap.min.css';

import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import store from './store/root.reducer';

import './languages/i18n';
import { FacebookProvider } from './contexts/FacebookContext';
import { GoogleProvider } from './contexts/GoogleContext';

// import * as Sentry from '@sentry/react';
import NotFound from './pages/NotFound/NotFound';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <Sentry.ErrorBoundary fallback={<NotFound />}>
  <Provider store={store}>
    <GoogleProvider>
      <FacebookProvider>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </FacebookProvider>
    </GoogleProvider>
  </Provider>
  // </Sentry.ErrorBoundary>
);

// Suppress findDOMNode warning for antd
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    ['findDOMNode', 'rc-collapse', 'Warning'].some(item =>
      args[0].includes(item)
    )
  ) {
    return;
  }
  originalError(...args);
};
// Tắt warning (chỉ dùng trong development)
console.warn = () => {};
